import { Box, Button, Card, CardContent, CircularProgress, Grid, TextField } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { Auth } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';

import { useAuthStyles } from './styles';
import { useFormFields } from '../../../lib/hooks.lib';
import { ApplicationFormContainer } from '../../../private/pages/ApplicationsForm/applications-form.styles';

interface CustomConfirmSignInProps {
  authState?: string;
  authData?: { username: string };
  [key: string]: unknown;
}

export const CustomConfirmSignIn = (props: CustomConfirmSignInProps): JSX.Element => {
  const classes = useAuthStyles();
  const authPiece = new AuthPiece(props);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [fields, handleFieldChange] = useFormFields({
    username: '',
    code: ''
  });

  const getErrorMessage = (error: unknown): string => {
    return error instanceof Error ? error.message : String(error);
  };

  useEffect(() => {
    if (props.authData) {
      handleFieldChange({ target: { id: 'username', value: props.authData.username } });
      console.log(props.authData);
    }
  }, [props.authData]);

  const handleConfirmSignIn = async (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>): Promise<void> => {
    event.preventDefault();
    setLoading(true);
    try {
      await Auth.confirmSignIn(props.authData, fields.code, 'SMS_MFA');
      setLoading(false);
      authPiece.changeState('signedIn', props.authData);
      setErrorMessage(undefined);
    } catch (error) {
      console.log(error);
      setErrorMessage(getErrorMessage(error));
      setLoading(false);
    }
  };

  const renderConfirmSignIn = () => (
    <ApplicationFormContainer>
      <Box ml={4} mr={4} mb={3}>
        {errorMessage && (
          <Alert
            severity="error"
            onClose={() => {
              setErrorMessage(undefined);
            }}
          >
            {errorMessage}
          </Alert>
        )}
        <Grid container justifyContent="center">
          <Grid item>
            <Typography variant="h4">Confirm Sign In</Typography>
            <Typography variant="body1">Enter the 6-digit code we sent to your phone.</Typography>
          </Grid>
        </Grid>
      </Box>
      <Box pt={3} mb={3}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={10} sm={5}>
            <Card>
              <CardContent>
                <form noValidate>
                  <Grid container justifyContent="space-between" spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        required
                        id="username"
                        name="username"
                        label="Username"
                        type="text"
                        fullWidth
                        disabled
                        value={fields.username}
                        onChange={handleFieldChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputMask mask="999999" disabled={false} maskChar={null} value={fields.code} onChange={handleFieldChange}>
                        {() => <TextField required id="code" name="code" label="Code" type="code" fullWidth autoFocus />}
                      </InputMask>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center">
                    <Grid item style={{ marginTop: '20px' }}>
                      <Button
                        variant="contained"
                        type="submit"
                        color="primary"
                        className={classes.button}
                        onClick={(e) => handleConfirmSignIn(e)}
                      >
                        Confirm
                        {loading && (
                          <Box ml={2} mt={1}>
                            <CircularProgress size="0.8rem" color={'inherit'} />
                          </Box>
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                  <Link
                    style={{ marginTop: '20px' }}
                    component="button"
                    type="button"
                    onClick={() => {
                      authPiece.changeState('signIn');
                      setErrorMessage(undefined);
                    }}
                    variant="body2"
                  >
                    Back to sign in
                  </Link>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </ApplicationFormContainer>
  );

  return <div>{props.authState === 'confirmSignIn' && renderConfirmSignIn()}</div>;
};
